export default "__VITE_ASSET__7ecd0ac0__"